export const FIXED_STRD_SUPPLY = 100_000_000

// Sanitize number input - returns valid number or 0
export const getNumberInput = (value: string | number): number => {
  const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value
  return !isNaN(num) && isFinite(num) ? num : 0
}

// Format percentage with 2 decimals. For small values aboves 0, we'll show 4 decimals
export const formatPercentage = (value: string | number): string => {
  const n = typeof value === 'string' ? Number(value) : value
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: n > 0 && n < 0.01 ? 4 : 2
  })
  return `${formatter.format(isFinite(n) ? n : 0)}%`
}

export const formatStatPercentage = (value: string | number): string => {
  const n = Number(value)
  // If value is between 0% and 1%, display in basis points ("bips")
  if (n > 0 && n < 1) {
    const bips = n * 100 // since n is already a percent value, 1% => 100 bips
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: bips > 0 && bips < 1 ? 4 : 2
    })
    return `${formatter.format(isFinite(bips) ? bips : 0)} bips`
  }
  return formatPercentage(value)
}

// Format STRD token values with k/m/b notation, max 2 decimals
export const formatStrd = (value: number): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  })

  return formatter.format(value)
}
